"use strict";
import styled from "lib/styled-components";
import { useTranslation } from "react-i18next";
import { ThemeSelector } from "theme/components/ThemeToggle";
import { Flex, Text } from "ui/src";
const Pref = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;
export function PreferenceSettings({
  showThemeLabel = true
}) {
  const { t } = useTranslation();
  const items = [
    {
      label: showThemeLabel ? t("themeToggle.theme") : void 0,
      component: <ThemeSelector compact fullWidth={!showThemeLabel} />
    }
  ];
  return <>
      <Flex gap="$gap12" mt="$spacing8">
        {items.map(({ label, component }, index) => <Pref key={`${label}_${index}`}>
            {label && <Text variant="body2" color="$neutral2" textAlign="left">
                {label}
              </Text>}
            {component}
          </Pref>)}
      </Flex>
    </>;
}
